export enum VoucherTypeEnum {
  Benefit = "b",
  Normal = "g",
  Compensation = "k",
  Other = "",
}
